import React from 'react';
import './style.css';

const VisibilityPlaceholder = () => (
  <div className='visibility-placeholder'>Loading...</div>
);

export default React.memo(VisibilityPlaceholder);
